import { render, staticRenderFns } from "./jyhRanking.vue?vue&type=template&id=c448cf44&scoped=true&"
import script from "./jyhRanking.vue?vue&type=script&lang=ts&"
export * from "./jyhRanking.vue?vue&type=script&lang=ts&"
import style0 from "./jyhRanking.vue?vue&type=style&index=0&id=c448cf44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448cf44",
  null
  
)

export default component.exports